module.exports = new __parcel__URL__("jpd-prioritization-idea-dark.6d9c45cf.svg").toString();